import { render, staticRenderFns } from "./assetHistory.vue?vue&type=template&id=fcd9fc6a&"
import script from "./assetHistory.vue?vue&type=script&lang=js&"
export * from "./assetHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports